import PropTypes from 'prop-types';

export const CustomPropType = {
  props: PropTypes.any
};

export const CustomAutocompletePropTypes = {
  fieldName: PropTypes.any,
  fieldOptions: PropTypes.any,
  onSelectValue: PropTypes.any,
};

export const CustomTooltipPropTypes = {
  children: PropTypes.any,
  content: PropTypes.any,
  backgroundColor: PropTypes.any,
  html: PropTypes.bool,
  placement: PropTypes.string
};

export const CustomDatePicker = {
  onDateChange: PropTypes.any,
  minDate: PropTypes.any,
  isDisabled: PropTypes.any,
};

export const ClientDetails = {
  show: PropTypes.any,
  clientData: PropTypes.any,
  close: PropTypes.any,
};

export const TablePropTypes = {
  headers: PropTypes.any,
  data: PropTypes.any,
  pageNo: PropTypes.any,
  tableInfo: PropTypes.any,
  size: PropTypes.any,
  total: PropTypes.any,
};

export const InputDialogPropTypes = {
  show: PropTypes.any,
  data: PropTypes.any,
  close: PropTypes.any,
};

export const SessionNotesPropTypes = {
  show: PropTypes.any,
  data: PropTypes.any,
  sessionEvent: PropTypes.any,
  close: PropTypes.any,
  additionalInfo: PropTypes.any
};

export const CalendarDialogPropTypes = {
  show: PropTypes.any,
  getDate: PropTypes.any,
  closeDailog: PropTypes.any,
};

export const RatingDialogPropTypes = {
  show: PropTypes.any,
  onClose: PropTypes.any,
  onSubmit: PropTypes.any,
  name: PropTypes.any,
  id: PropTypes.any,
  image: PropTypes.any,
  method: PropTypes.any,
};

export const ConfirmDailogPropTypes = {
  message: PropTypes.any,
  show: PropTypes.any,
  handleClose: PropTypes.any
};

export const FooterPropTypes = {
  isOpen: PropTypes.any,
};

export const SidebarPropTypes = {
  isOpen: PropTypes.any,
  toggleSidebar: PropTypes.any,
  isMobileView: PropTypes.any,
};

export const ProfileInfoPropTypes = {
  user: PropTypes.any,
};

export const BookingModalPropTypes = {
  timeSlot: PropTypes.any,
  show: PropTypes.any,
  onClose: PropTypes.any,
  onSubmit: PropTypes.any
};

export const AuthContextProviderPropTypes = {
  children: PropTypes.any,
};

export const MultiStepFormPropTypes = {
  step: PropTypes.any,
  onFormDataChange: PropTypes.any
};

export const MhaPropTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.any
};

export const CalendarHeaderPropTypes = {
  currentDate: PropTypes.any,
  onTherapistChange: PropTypes.any
};

export const TimeSlotCellPropTypes = {
  currentDate: PropTypes.any,
  timeSlot: PropTypes.any,
  onClick: PropTypes.any,
};

export const DateSlotPropTypes = {
  show: PropTypes.any,
  id: PropTypes.any,
  therapistName: PropTypes.any,
  handleClose: PropTypes.any,
  reschedule: PropTypes.any,
  eventId: PropTypes.any
};

export const CancelSessionPropTypes = {
  show: PropTypes.any,
  data: PropTypes.any,
  handleClose: PropTypes.any,
};

export const ViewSessionPropTypes = {
  show: PropTypes.any,
  data: PropTypes.any,
  handleClose: PropTypes.any,
  therapistName: PropTypes.any,
};

export const ErrorHeadingPropTypes = {
  code: PropTypes.any,
  title: PropTypes.any,
  description: PropTypes.any
};

export const ExpertisePropTypes = {
  expertise: PropTypes.any,
};

export const QualificationsPropTypes = {
  qualifications: PropTypes.any,
};

export const LanguagesPropTypes = {
  languages: PropTypes.any,
};

export const PlanFormFieldsPropTypes = {
  values: PropTypes.any,
  errors: PropTypes.any,
  touched: PropTypes.any,
  planTypes: PropTypes.any,
  therapySession: PropTypes.any,
  workshopType: PropTypes.any,
  services: PropTypes.any,
  newsLetter: PropTypes.any,
  isView: PropTypes.any,
  isEdit: PropTypes.any,
  onInputChange: PropTypes.any,
  onInputValidation: PropTypes.any,
  handleChange: PropTypes.any,
  handleBlur: PropTypes.any,
};